"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerActionType = exports.CustomerListItem = exports.IntakeInfo = exports.Notifications = exports.CALVES_CHARACTERISTIC = exports.BUTTOCKS_CHARACTERISTIC = exports.LOVE_HANDLES_CHARACTERISTIC = exports.WAIST_CHARACTERISTIC = exports.LEGS_CHARACTERISTIC = exports.BELLY_CHARACTERISTIC = exports.BREAST_CHARACTERISTIC = exports.UPPER_ARMS_CHARACTERISTIC = exports.SHOULDERS_CHARACTERISTIC = exports.NECK_CHARACTERISTIC = void 0;
var NECK_CHARACTERISTIC;
(function (NECK_CHARACTERISTIC) {
    NECK_CHARACTERISTIC["SHORT"] = "short";
    NECK_CHARACTERISTIC["IN_PROPORTION"] = "in_proportion";
    NECK_CHARACTERISTIC["LANG"] = "lang";
})(NECK_CHARACTERISTIC = exports.NECK_CHARACTERISTIC || (exports.NECK_CHARACTERISTIC = {}));
var SHOULDERS_CHARACTERISTIC;
(function (SHOULDERS_CHARACTERISTIC) {
    SHOULDERS_CHARACTERISTIC["NARROW"] = "narrow";
    SHOULDERS_CHARACTERISTIC["IN_PROPORTION"] = "in_proportion";
    SHOULDERS_CHARACTERISTIC["WIDE"] = "wide";
})(SHOULDERS_CHARACTERISTIC = exports.SHOULDERS_CHARACTERISTIC || (exports.SHOULDERS_CHARACTERISTIC = {}));
var UPPER_ARMS_CHARACTERISTIC;
(function (UPPER_ARMS_CHARACTERISTIC) {
    UPPER_ARMS_CHARACTERISTIC["THIN"] = "thin";
    UPPER_ARMS_CHARACTERISTIC["MUSCULAR"] = "muscular";
    UPPER_ARMS_CHARACTERISTIC["FIRM"] = "firm";
})(UPPER_ARMS_CHARACTERISTIC = exports.UPPER_ARMS_CHARACTERISTIC || (exports.UPPER_ARMS_CHARACTERISTIC = {}));
// TODO: Fixed
var BREAST_CHARACTERISTIC;
(function (BREAST_CHARACTERISTIC) {
    // male
    BREAST_CHARACTERISTIC["NO_CHEST"] = "no_chest";
    BREAST_CHARACTERISTIC["MUSCULAR_CHEST"] = "muscular_chest";
    BREAST_CHARACTERISTIC["FEMALE_CHEST"] = "female_chest";
    // female
    BREAST_CHARACTERISTIC["SMALL"] = "small";
    BREAST_CHARACTERISTIC["IN_PROPORTION"] = "in_proportion";
    BREAST_CHARACTERISTIC["LARGE"] = "large";
})(BREAST_CHARACTERISTIC = exports.BREAST_CHARACTERISTIC || (exports.BREAST_CHARACTERISTIC = {}));
var BELLY_CHARACTERISTIC;
(function (BELLY_CHARACTERISTIC) {
    BELLY_CHARACTERISTIC["FLAT"] = "flat";
    BELLY_CHARACTERISTIC["MUSCULAR"] = "muscular";
    BELLY_CHARACTERISTIC["FIRM"] = "firm";
})(BELLY_CHARACTERISTIC = exports.BELLY_CHARACTERISTIC || (exports.BELLY_CHARACTERISTIC = {}));
var LEGS_CHARACTERISTIC;
(function (LEGS_CHARACTERISTIC) {
    LEGS_CHARACTERISTIC["THIN"] = "thin";
    LEGS_CHARACTERISTIC["MUSCULAR"] = "muscular";
    LEGS_CHARACTERISTIC["FIRM"] = "firm";
})(LEGS_CHARACTERISTIC = exports.LEGS_CHARACTERISTIC || (exports.LEGS_CHARACTERISTIC = {}));
var WAIST_CHARACTERISTIC;
(function (WAIST_CHARACTERISTIC) {
    WAIST_CHARACTERISTIC["NO_LOVE_HANDLES"] = "no_love_handles";
    WAIST_CHARACTERISTIC["IN_PROPORTION"] = "in_proportion";
    WAIST_CHARACTERISTIC["WELL_LOVE_HANDLES"] = "well_love_handles";
})(WAIST_CHARACTERISTIC = exports.WAIST_CHARACTERISTIC || (exports.WAIST_CHARACTERISTIC = {}));
var LOVE_HANDLES_CHARACTERISTIC;
(function (LOVE_HANDLES_CHARACTERISTIC) {
    LOVE_HANDLES_CHARACTERISTIC["NARROW"] = "narrow";
    LOVE_HANDLES_CHARACTERISTIC["IN_PROPORTION"] = "in_proportion";
    LOVE_HANDLES_CHARACTERISTIC["WIDE"] = "wide";
})(LOVE_HANDLES_CHARACTERISTIC = exports.LOVE_HANDLES_CHARACTERISTIC || (exports.LOVE_HANDLES_CHARACTERISTIC = {}));
var BUTTOCKS_CHARACTERISTIC;
(function (BUTTOCKS_CHARACTERISTIC) {
    BUTTOCKS_CHARACTERISTIC["FLAT"] = "flat";
    BUTTOCKS_CHARACTERISTIC["MUSCULAR"] = "muscular";
    BUTTOCKS_CHARACTERISTIC["FIRM"] = "firm";
})(BUTTOCKS_CHARACTERISTIC = exports.BUTTOCKS_CHARACTERISTIC || (exports.BUTTOCKS_CHARACTERISTIC = {}));
var CALVES_CHARACTERISTIC;
(function (CALVES_CHARACTERISTIC) {
    CALVES_CHARACTERISTIC["THIN"] = "thin";
    CALVES_CHARACTERISTIC["MUSCULAR"] = "muscular";
    CALVES_CHARACTERISTIC["FIRM"] = "firm";
})(CALVES_CHARACTERISTIC = exports.CALVES_CHARACTERISTIC || (exports.CALVES_CHARACTERISTIC = {}));
class Notifications {
}
exports.Notifications = Notifications;
class IntakeInfo {
}
exports.IntakeInfo = IntakeInfo;
class CustomerListItem {
}
exports.CustomerListItem = CustomerListItem;
var CustomerActionType;
(function (CustomerActionType) {
    CustomerActionType["PLAN_REQUIRES_CALORIE_BUDGET_ADJUSTMENT"] = "PLAN_REQUIRES_CALORIE_BUDGET_ADJUSTMENT";
    CustomerActionType["PLAN_REQUIRES_NUMBER_OF_HANDPALMS_ADJUSTMENT"] = "PLAN_REQUIRES_NUMBER_OF_HANDPALMS_ADJUSTMENT";
})(CustomerActionType = exports.CustomerActionType || (exports.CustomerActionType = {}));
//# sourceMappingURL=CustomerInterface.js.map